import React, { useState } from "react";
import { Divider, Typography, useMediaQuery } from "@mui/material";

import ExpandInfo from "./ExpandInfo";

const Pas2 = () => {
  const isLaptop = useMediaQuery("(max-width: 1400px)");
  const isMobile = useMediaQuery("(max-width: 1024px)");

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? "20px" : "140px",
          marginRight: isMobile ? -20 : "140px",
          marginTop: isMobile ? -60 : "50px",
        }}
      >
        {!isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: isLaptop ? "56rem" : "43rem",
              width: "4px",
              backgroundColor: "#29348f",
            }}
          />
        ) : (
          ""
        )}
        <div style={{ marginLeft: isMobile ? 10 : 34 }}>
          <div
            variant="contained"
            style={{
              backgroundColor: "#29348f",
              borderRadius: isMobile
                ? "20px 0px 0px 20px"
                : "0px 20px 20px 0px",
              textTransform: "none",
              height: 40,
              width: 80,
              paddingLeft: 16,
              paddingTop: 8,
              marginLeft: isMobile ? "auto" : "",
            }}
          >
            <Typography variant="body1" color="white">
              Client
            </Typography>
          </div>
          <Typography variant="h6" sx={{ mt: 5 }}>
            Depunerea cererii de racordare și a documentelor aferente
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Informații generale privind condițiile și posibilitățile de
            realizare a racordării la rețea a locului de consum și/sau de
            producere:
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            Personal, la Centrele de Relații cu Utilizatorii;
          </Typography>
          {/* <Typography variant="body2" sx={{ mt: 0 }}>
            E-mail, la adresa: office@distributie-energie.ro;
          </Typography> */}
          <Typography variant="body2" sx={{ mt: 0 }}>
            Poștă/curier;
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            Canale de comunicare electronică (portal).
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            Prin împuternicit în numele și pe seama solicitantului;
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            Prin furnizorul de energie electrică în numele și pe seama
            solicitantului, pentru locurile de consum aferente clienților
            casnici;
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            Adresele de corespondență le găsiți pe site-ul DEER la{" "}
            <a
              href="https://www.distributie-energie.ro/informatii-generale/"
              style={{ color: "#0D6D92" }}
            >
              {" "}
              adrese de corespondență{" "}
            </a>{" "}
          </Typography>
          <Typography variant="h6" sx={{ mt: 4 }}>
            Formulare racordare la rețea
          </Typography>

          <Typography variant="body2" sx={{ mt: 2, color: "#0D6D92" }}>
            Prosumatori
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            <a
              href="./5.-Cerere-de-racordare-prosumator-–-prin-programe-de-finantare-Anexa-4.docx"
              style={{ color: "#0D6D92" }}
            >
              Cerere de racordare prosumator – prin programe de finantare.
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./5.-Loc-consum-si_sau-producere-existent-prevazut_cu_instalatii_de_producere_Anexa-nr-5.docx"
              style={{ color: "#0D6D92" }}
            >
              Notificare prosumatori si proiecte demonstrative – Pi mai mica sau
              egală cu 10,8 kW, conexiune diferita de trifazic (Anexa 5)
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./CERERE-PROSUMATOR-mai-mare-400-kW-5.doc"
              style={{ color: "#0D6D92" }}
            >
              Persoane fizice si juridice care au puterea instalata pe producere
              &gt; 400kW
            </a>
          </Typography>

          <Typography variant="h6" sx={{ mt: 4 }}>
            Cererea de racordare este necesar să fie însoțită de urmatoarele
            documente
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            <a
              href="./Declaratie-autenticitate-date-racordare.doc"
              style={{ color: "#0D6D92" }}
            >
              Declaratie autenticitate date - cerere racordare –
            </a>
            Obligatoriu pentru toate tipurile de cereri
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./12-Model-de-imputernicire.pdf"
              style={{ color: "#0D6D92" }}
            >
              Model imputernicire –
            </a>{" "}
            În cazul în care cererea se depune prin împuternicit
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./Nota-informare-clienti-DEER-final.doc"
              style={{ color: "#0D6D92" }}
            >
              Nota de informare generală privind prelucrarea datelor cu caracter
              personal –
            </a>{" "}
            În cazul persoanelor fizice
          </Typography>
          <Typography variant="h6" sx={{ mt: 2, color: "#29348f" }}>
            Cât durează?
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            5 zile lucrătoare OD verifică documentația depusă
          </Typography>
        </div>
        {isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: "72rem",
              width: "4px",
              backgroundColor: "#29348f",
              ml: 2,
            }}
          />
        ) : (
          ""
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? -30 : "140px",
          marginTop: "50px",
          marginRight: isMobile ? 0 : "140px",
          marginBottom: "60px",
        }}
      >
        <Divider
          orientation="vertical"
          sx={{ height: "4rem", width: "4px", backgroundColor: "#29348f" }}
        />
        <ExpandInfo />
      </div>
    </div>
  );
};
export default Pas2;
